import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string
}

export default function Link({ href, children, ...props }: Props) {
  const internal = href.startsWith('/') && !href.startsWith('//')
  if (internal) return <GatsbyLink to={href} {...props}>{children}</GatsbyLink>
  return <a href={href} {...props}>{children}</a>
}
